import { Link } from "react-router-dom";
import { Star, Building2 } from "lucide-react";
import { Company } from "@/types";
import { cn } from "@/lib/utils";

type Props = {
  company: Company;
  dark?: boolean;
};

export default function CompanyCard({ company, dark }: Props) {
  return (
    <Link
      to={`/cong-ty/${company.id}`}
      className={cn(
        "fnb-card flex flex-col items-center justify-center gap-1.5 p-4 aspect-[4/3] text-center cursor-pointer transition-all hover:scale-[1.02]",
        dark ? "bg-[#111] border-gray-800" : "bg-white"
      )}
    >
      <div className="w-12 h-12 rounded-lg border overflow-hidden shrink-0 flex items-center justify-center bg-white mb-1">
        {company.logoUrl ? (
          <img
            src={company.logoUrl}
            alt={company.name}
            className="w-full h-full object-contain p-1"
          />
        ) : (
          <Building2 size={20} className="text-gray-300" />
        )}
      </div>

      <p className={cn("text-xs font-bold leading-tight truncate w-full", dark ? "text-white" : "text-gray-900")}>
        {company.name}
      </p>

      {company.industry && (
        <p className={cn("text-[9px] leading-tight opacity-60 truncate w-full text-center", dark ? "text-gray-400" : "text-gray-500")}>
          {company.industry}
        </p>
      )}

      {company.rating && (
        <div className="flex items-center gap-0.5 text-amber-500 font-bold text-[10px] mt-1">
          <Star size={10} fill="currentColor" />
          {company.rating}
        </div>
      )}
    </Link>
  );
}
